import React, {useCallback, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import DataGrid from '@dtci/spellbook/DataGrid';
import styles from '../../../../components/AGGrid/details-table.module.scss';
import {datastageApi} from '../../../../api';
import {filterCriteria} from '../../../../utils/filterCriteria';
import {useAgGridApi} from '../../../../components/AGGrid/hooks';
import {useLoading} from '../../../../utils/hooks/useLoading';
import {useContactsDialog} from '../../../../components/dialogs/dialogs/contacts';
import {useContactsActions} from '../../../../store/contacts/useContacts';
import {useContactsGridUtils} from "./utils/gridUtils";

export const ContactsGrid = () => {
    const agGridApi = useAgGridApi();
    const {contacts, filterForm, contactRange, defaultFilterRange, contactSort} = useSelector((s) => s.contacts);
    const {setLoadingTrue, setLoadingFalse} = useLoading();
    const {openContactsDialog} = useContactsDialog();
    const {updateContacts} = useContactsActions();

    const {
        setSort,
        columns
    } = useContactsGridUtils({
        datastageApi,
        filterForm,
        defaultFilterRange,
        updateContacts,
        handlers: {
            setLoadingTrue,
            setLoadingFalse,
            columnHandlers: []
        }
    });

    const onRowClicked = useCallback(
        (event) => {
            openContactsDialog(event.data, 'Edit Contact', async ({formData}) => {
                try {
                    setLoadingTrue();
                    await datastageApi.updateContact(formData);
                    const data = await datastageApi.contacts(
                        filterCriteria(filterForm, '', 'contacts'),
                        contactRange,
                        contactSort,
                    );
                    updateContacts({
                        contacts: data?.content,
                        totalPages: data?.totalPages,
                        totalItems: data?.totalElements,
                        currentPage: data?.pageable?.pageNumber,
                    });
                } catch (error) {
                    console.error('Error updating contact:', error);
                } finally {
                    setLoadingFalse();
                }
            });
        },
        [
            filterForm,
            contactRange,
            contactSort,
            openContactsDialog,
            setLoadingTrue,
            setLoadingFalse,
            updateContacts,
        ],
    );

    return (
        <DataGrid
            className={styles.dataGrid}
            autoHeight
            autoSizing
            agGrid={{
                ref: agGridApi.AgGridApiRef,
                rowData: contacts,
                headerHeight: 45,
                onRowClicked,
            }}
            bordered="none"
            columnDefs={columns}
            sortable={false}
            striped
            noResultsMessage={'No Contacts'}
        />
    );
};